import { makeMutation } from '../types';

type Output = boolean;

export const sendConfirmationEmail = makeMutation<Output>(`
    mutation SendConfirmationEmail {
      sendConfirmationEmail
    }
`);
